import { IconItalic } from '@xing-com/icons';

import * as Styled from '../styles';
import { type ToolProps } from '../types';

export const ItalicTool: React.FC<ToolProps> = ({ editor, disabled }) => {
  return (
    <Styled.ToolBarButton
      onClick={() => editor.chain().focus().toggleItalic().run()}
      disabled={disabled || !editor.can().chain().focus().toggleItalic().run()}
      className={editor.isActive('italic') ? 'is-active' : ''}
    >
      <IconItalic width={24} height={24} />
    </Styled.ToolBarButton>
  );
};
